module.exports = __webpack_public_path__ + "static/media/about.159b48fe.jpg";